import { Icon, Tooltip } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';

export const PhysicalMetricIndicator = () => {
  const { t } = useTranslation('filters');
  const label = t('metricPhysicalIndicator');
  return (
    <Tooltip content={label}>
      <Icon variant="Tracking" size="small" ariaLabel={label} />
    </Tooltip>
  );
};
